import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { ConfigService } from './app-config.service';
import { SystemService } from "./system.service";
import { UserService } from './user.service';

@Injectable()
export class AuthGuardService {
    constructor(private router: Router, private systemService: SystemService, private configService: ConfigService, private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return new Observable(
            observer => {
                this.validateSessionData(route.data).then((valido: any) => {
                    observer.next(valido);
                    observer.complete();
                });
            }
        );
    }

    canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
        return new Observable(
            observer => {
                observer.next(true);
                observer.complete();
            }
        );
    }

    isLoggedOut(route: ActivatedRouteSnapshot): Observable<boolean> {
        return new Observable(
            observer => {
                this.validateSessionData(route.data).then((valido: any) => {
                    observer.next(!valido);
                    observer.complete();
                });
            });

    }

    isLoggedIn(route: ActivatedRouteSnapshot): Observable<boolean> {
        return new Observable(
            observer => {
                this.validateSessionData(route.data).then((valido: any) => {
                    observer.next(valido);
                    observer.complete();
                });
            });
    }

    validateSessionData(data: any)
    {
        return new Promise((resolve) => {
          // Siempre cargar datos iniciales básicos (lenguajes, parámetros)
          this.userService.loadInitialData().then((response: any) => {
            if (localStorage.getItem(this.systemService.localStoreVariable.JWT)){
              if (!this.systemService.loadedPermissions && data.modulo != 'sesion' && data.modulo != 'registro') {
                  this.userService.loadPermissions().then((response) => {
                      return resolve(this.validateAccess(data));
                  });
              }
              else {
                  return resolve(this.validateAccess(data));
              }
            } else {
              return resolve(this.validateAccess(data));
            }
          }).catch(() => {
            // Si falla la carga de datos iniciales, aún permitir acceso
            return resolve(this.validateAccess(data));
          });
        });
    }

    validateAccess(data: any)
    {
        if (localStorage.getItem(this.systemService.localStoreVariable.JWT))
        {
            if (data.modulo == 'app' && !this.systemService.user.resetPassword)
            {
                if (data.permisos && !this.systemService.hasAccess(data.permisos))
                {
                  if(data.submodule == 'datos'){
                    this.router.navigateByUrl('/visitantes');
                    return false;
                  }else{
                    this.router.navigateByUrl('/app/home');
                    return false;
                  }
                }
            }
            else if (data.modulo == 'cambiarpassword')
            {
                return true;
            }
            else if (data.modulo == 'sesion' || data.modulo == 'registro')
            {
                this.router.navigateByUrl('/app/home');
                return false;
            } else if (this.systemService.user.resetPassword) {
                this.router.navigateByUrl('/auth/change-password');
                return false;
            }
        }
        else if (!data.modulo || data.modulo == 'registro') {
            return true;
        } else if (data.modulo != 'sesion' && data.submodule != 'datos')
          {
            this.router.navigateByUrl('/auth/login');
            return false;
        }else if (data.submodule == 'datos'){
          this.router.navigateByUrl('/visitantes');
          return false;
        }
        else {
            return true;
        }

        return true;
    }
}
